import { styled } from '@material-ui/core/styles';
import { Form } from 'formik';

export const ContainerForm = styled(Form)({
  margin: '8px 0px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',

  '& .MuiOutlinedInput-root': {
    borderRadius: 12,

    '& input': {
      fontSize: 16,
      padding: '14px 12px',
      '&::placeholder': {
        color: '#5D7083',
        opacity: 1
      }
    },

    '& fieldset': {
      border: '1px solid #AFBAC6'
    }
  }
});
